import React, { useEffect, useState } from "react";
import { v4 as uuid } from "uuid";
import Select from "react-select";
import { IoIosArrowDropdown } from "react-icons/io";
import "./addnewclient.css";

import axiosinstances, { baseURL } from "../../Helper/useAxios";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { stylesofStype } from "../../utils/comman/Common";
import { array } from "yup";
// import { getToken } from "../../utils/comman/permission";
const navigatePage = "/user-list";
const ENABLE = "ENABLE";
const CHECKBOX = "CHECKBOX";
const API = "API";
const P2P = "P2P";
export default function AddNewClient() {
  const rolelist = process.env.REACT_APP_ALLOWED_TXN_ROLELIST;
  const roleListJson = JSON.parse(rolelist);
  const navigate = useNavigate();
  const locations = useLocation();
  const { isUpdate, data } = locations.state;
  const mid = JSON.parse(sessionStorage.getItem("mid"));
  const sessionId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.sessionId
  );
  const reqId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.requestId
  );

  const e = JSON.parse(sessionStorage.getItem("token"));

  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": sessionId,
    "request-id": reqId,
  };
  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const [axiosInstance] = axiosinstances(userIp);
  const [isCustomizedApi, setIsCustomizedApi] = useState(false);
  const [isCustomizedPtp, setIsCustomizedPtp] = useState(false);
  const [roleList, setroleList] = useState();
  const [personalDetails, setPersonalDetails] = useState({
    mid: mid,
    name: "",
    mobile: "",
    email: "",
    password: "",
    roles: [],
  });

  useEffect(() => {
    if (isUpdate) {
      setPersonalDetails(data);
      if (Array.isArray(data.roles) && data.roles.length > 0) {
        const showRoleList = data.roles.map((val) => ({
          label: val,
          value: val,
        }));
        setroleList(showRoleList);
      }
    }
  }, [data]);
  const isValidEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const check = emailPattern.test(email);

    return check;
  };

  const handlerInfoChange = (e, enable, checkbox) => {
    const { name, value } = e.target;
    let inputValue = value;

    if (name === "mobile") {
      // Remove non-numeric characters and limit to 10 digits
      inputValue = value.replace(/\D/g, "").slice(0, 10);
    } else if (name === "email") {
      // Validate email format using validator
      inputValue = value.toLowerCase().trim(); // Convert to lowercase and remove leading/trailing spaces
    }

    setPersonalDetails({
      ...personalDetails,
      [name]: inputValue,
    });
  };
  // console.log("personalDetails", personalDetails);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValidEmail(personalDetails?.email)) {
      toast.error("Email id is not valid");
      return;
    }
    if (personalDetails?.roles.length <= 0) {
      toast.error("Select a role for this user");
      return;
    }
    if (isUpdate) {
      const API_ENDPOINT = "/api/v1/upi/merchant/user/update";
      try {
        const requestPayload = {
          ...personalDetails,
        };

        const response = await axiosInstance.post(
          API_ENDPOINT,
          requestPayload,
          {
            headers,
          }
        );

        if (response.status === 200 && response?.data?.name !== undefined) {
          // console.log("response", response);
          toast.success(`Updated User details ${response?.data?.name}`);
          navigate(navigatePage);
        } else {
          // console.log("res", response);
          throw new Error(response?.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);

        toast.error(error?.message);
        return false;
      }
    } else {
      const API_ENDPOINT = "/api/v1/upi/merchant/user/add";
      try {
        const requestPayload = {
          ...personalDetails,
        };

        const response = await axiosInstance.post(
          API_ENDPOINT,
          requestPayload,
          {
            headers,
          }
        );

        if (response.status === 200 && response?.data?.name !== undefined) {
          console.log("response", response);

          toast.success(`Added New User ${response?.data?.name}`);

          navigate(navigatePage);
          // return data;
        } else {
          console.log("res", response);
          throw new Error(response?.response?.data?.message || response?.error);
        }
      } catch (error) {
        console.error("Error fetching data:", error);

        toast.error(error?.message);
        return false;
      }
    }
  };
  useEffect(() => {
    if (Array.isArray(roleList) && roleList.length > 0) {
      const selectedRole = roleList.map((val) => val?.value);
      setPersonalDetails((prev) => ({ ...prev, roles: selectedRole }));
    } else if (Array.isArray(roleList) && roleList.length == 0) {
      setPersonalDetails((prev) => ({ ...prev, roles: roleList }));
    }
  }, [roleList]);

  const goback = () => {
    navigate(navigatePage);
  };

  return (
    <div class="mid-contant">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="head">
              <h2>{`${isUpdate ? "Update" : "Register"}`} User</h2>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="registerbox">
                <div class="row mb-3">
                  <div class="col-12 col-lg-12">
                    <form onSubmit={(e) => handleSubmit(e)}>
                      <div class="row">
                        <div style={{ marginTop: "0px" }} class="separator">
                          <span class="separator_text">User Details</span>
                        </div>

                        <div id="add_account_color" class="col-12 col-md-4">
                          <div class="form-floating">
                            <input
                              required
                              type="text"
                              class="form-control"
                              id="name"
                              name="name"
                              onChange={(e) => handlerInfoChange(e)}
                              value={personalDetails?.name}
                              placeholder="Enter first name"
                            />
                            <label for="name">Name</label>
                          </div>
                        </div>

                        <div id="add_account_color" class="col-12 col-md-4">
                          <div class="form-floating">
                            {/* <input type="tel" pattern="[0-9]{10}" class="form-control" id="mobile" maxLength={10} placeholder="Enter mobile no." name='contactMobile' onChange={(e)=>handlerInfoChange()} value={personalDetails?.contactMobile}/> */}
                            <input
                              type="tel"
                              pattern="[0-9]{10}"
                              className="form-control"
                              id="mobile"
                              maxLength={10}
                              placeholder="Enter mobile no."
                              name="mobile"
                              onChange={handlerInfoChange}
                              value={personalDetails.mobile}
                              required
                            />
                            <label for="mobile">Mobile number</label>

                            {/* {personalDetails.contactMobile.length > 1 && isMobileCorrect &&	<small style={{color:'red'}} >Enter Valid Mobile Number</small>} */}
                          </div>
                        </div>
                        <div id="add_account_color" class="col-12 col-md-4">
                          <div class="form-floating">
                            <input
                              required
                              type="email"
                              class="form-control"
                              id="email"
                              placeholder="Enter email id"
                              name="email"
                              onChange={(e) => handlerInfoChange(e)}
                              value={personalDetails.email}
                            />
                            <label for="email">Email ID</label>
                            {/* { personalDetails.contactEmail.length > 3 && isEmailCorrect &&	<small style={{color:'red'}} >Enter Valid Email id</small>} */}
                          </div>
                        </div>
                        <div id="add_account_color" class="col-12 col-md-4">
                          <div class="form-floating">
                            <input
                              required
                              type="password"
                              class="form-control"
                              id="password"
                              placeholder="Enter password"
                              name="password"
                              onChange={(e) => handlerInfoChange(e)}
                              value={personalDetails.password}
                            />
                            <label for="password">Password</label>
                            {/* { personalDetails.contactEmail.length > 3 && isEmailCorrect &&	<small style={{color:'red'}} >Enter Valid Email id</small>} */}
                          </div>
                        </div>

                        <div id="add_account_color" className="col-12 col-md-8">
                          <div class="form-floating">
                            <Select
                              className="basic-multi-select form-control"
                              styles={stylesofStype}
                              closeMenuOnSelect={true}
                              components={{
                                IndicatorsContainer: () => null,
                                IndicatorSeparator: () => null,
                              }}
                              // closeMenuOnSelect={true}
                              isMulti
                              options={roleListJson}
                              onChange={(val) => setroleList(val)}
                              value={roleList}
                              placeholder="Select Role"
                            />
                            <label>
                              Role <IoIosArrowDropdown />
                            </label>
                          </div>
                        </div>

                        <div style={{ display: "flex" }} class="col-4">
                          <button
                            onClick={goback}
                            type="button"
                            class="btn btn-secondary"
                            id=""
                          >
                            Cancel
                          </button>
                          <button type="submit" class="btn btn-primary" id="">
                            Submit
                          </button>
                        </div>
                      </div>
                      {/* <div class="col-2">
                      <button type="submit" class="btn btn-primary" id="">
                        Submit
                      </button>
                    </div> */}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
